import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsOpen(false);
  }, [location]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Approach',
    path: '/approach'
  }, {
    name: 'Portfolio',
    path: '/portfolio'
  }, {
    name: 'Founder',
    path: '/founders'
  }, {
    name: 'Team',
    path: '/team'
  }, {
    name: 'Values',
    path: '/values'
  }, {
    name: 'Updates',
    path: '/updates'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-deepCanopy/90 backdrop-blur-md py-4 shadow-lg' : 'bg-transparent py-6'}`} data-id="element-198">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-199">
        <div className="flex items-center justify-between" data-id="element-200">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 group" data-id="element-201">
            <img src="https://cdn.magicpatterns.com/uploads/rLCDkCKprcJW1NkEV2aCi1/Vitality_Logo_Circle.png" alt="Vitality Logo" className="w-10 h-10 group-hover:scale-105 transition-transform duration-300" data-id="element-202" />
            <span className="text-xl font-bold tracking-tight text-white group-hover:text-vitalityTeal transition-colors" data-id="element-203">
              Vitality
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-204">
            {navLinks.map(link => <Link key={link.path} to={link.path} className="relative group py-2" data-id="element-205">
                <span className={`text-sm font-medium transition-colors duration-300 ${location.pathname === link.path ? 'text-vitalityTeal' : 'text-myceliumWhite/80 group-hover:text-white'}`} data-id="element-206">
                  {link.name}
                </span>
                <span className={`absolute bottom-0 left-0 h-0.5 bg-vitalityTeal transition-all duration-300 ${location.pathname === link.path ? 'w-full' : 'w-0 group-hover:w-full'}`} data-id="element-207" />
              </Link>)}
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden p-2 text-myceliumWhite hover:text-vitalityTeal transition-colors" data-id="element-208">
            {isOpen ? <X className="w-6 h-6" data-id="element-209" /> : <Menu className="w-6 h-6" data-id="element-210" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-211">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-deepCanopy/95 backdrop-blur-xl border-t border-white/5 overflow-hidden" data-id="element-212">
            <div className="px-4 py-6 space-y-4" data-id="element-213">
              {navLinks.map(link => <Link key={link.path} to={link.path} className={`block text-lg font-medium transition-colors ${location.pathname === link.path ? 'text-vitalityTeal' : 'text-myceliumWhite hover:text-white'}`} data-id="element-214">
                  {link.name}
                </Link>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}